import { createAction, props } from '@ngrx/store';

import { CounterpartyList, ErrorMessage, RequestPageParams } from '@shared/models';

export namespace CounterpartyActions {
  export const loadCounterparties = createAction('[Counterparty API] Load Counterparty', props<{ params: RequestPageParams }>());

  export const loadCounterpartySuccess = createAction(
    '[Counterparty API] Load Counterparty Success',
    props<{ counterparties: CounterpartyList['items']; totalElements: number }>(),
  );

  export const loadCounterpartyError = createAction('[Counterparty API] Load Counterparty Error', props<{ error: ErrorMessage }>());
}
